import { createAction, props } from '@ngrx/store';

export const updateAuditAction = createAction(
  '[Audit] update audit message',
  props<{ message: string }>(),
);

export const clearAuditAction = createAction('[Audit] clear audit message');

export const setToken = createAction(
  '[Audit] set token',
  props<{ token: string }>(),
);

export const setIsIframe = createAction(
  '[Audit] set isIframe',
  props<{ isIframe: boolean }>(),
);
